import PropTypes from 'prop-types';
import React from 'react';

import { Row, Col } from 'react-bootstrap';
import Measure from 'react-measure';

import NDATemplateView from './list/index.jsx';
import NDADetailsContainer from './details/';
import Slider from 'src/components/slider';
import DeleteNDASignatureContainer from './delete';

import styles from './Styles.module.scss';
import { isEqual } from 'lodash';
import { localizedStrings } from 'src/localization';
import Actions from 'src/components/actionbar';

class NDATemplatesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 300,
      create: this.props.params.id === 'new'
    }

    this._handleCreateNDA = this._handleCreateNDA.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._onDeleteSuccess = this._onDeleteSuccess.bind(this);

    // localized contents
    this.localizedGenerateLink = localizedStrings.components.generateLink;
    this.localizedNda = this.localizedGenerateLink.advanced_settings.options.nda;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedNdaTemplate = this.localizedSettings.templates.nda;
  }

  componentDidMount() {
    this.props.fetchAllNDATemplates();
    if (this.props.templates.length > 0) {
      var item = this.props.templates[0];
      this.props.navigate(`/settings/nda-templates/${item.id}`);
    }
  }

  componentWillReceiveProps(nextProps) {

    if (!this.props.params.id && nextProps.templates && nextProps.templates.length > 0) {
      var item = nextProps.templates[0];
      this.props.navigate(`/settings/nda-templates/${item.id}`);
    }

    if (this.props.templates.length == 0 && nextProps.templates && nextProps.templates.length > 0) {
      var item = nextProps.templates[0];
      this.props.navigate(`/settings/nda-templates/${item.id}`);
    }

    if(!isEqual(this.props.params.id, nextProps.params.id)){
      this.setState({
        create: nextProps.params.id === 'new', 
      })
    }
  }

  _handleCreateNDA(){
    this.props.navigate(`/settings/nda-templates/new`);
  }

  _handleDeleteClick(template) {
    this.setState({
      deleting: template
    })
  }

  _onDeleteSuccess() {
    this.setState({
      deleting: null,
    }, () => {
      var item = this.props.templates && this.props.templates.length > 0 ? this.props.templates[0] : null
      var url = "/settings/nda-templates";

      if(item){
        url = `/settings/nda-templates/${item.id}`;
      }

      this.props.navigate(url);
    })
  }

  render() {
    return (
      <div>
        <Measure bounds
          onResize={(contentRect) => {
            var height = contentRect.bounds.height;
            this.setState({
              height: height - 122
            })
          }}>

          {({ measureRef }) =>
            <div ref={measureRef} className={styles.content}>
              <div className={styles.headerRow}>
              <h3 className={styles.heading}>{this.localizedNda.title}</h3>
              <Actions.IconButton icon='paperflite-add' tooltip={this.localizedNdaTemplate.title}
                onClick={this._handleCreateNDA}
              />
              {/* <div className={cx(styles.action, styles.add)} onClick={this._handleCreateNDA}><i className="paperflite-add"/> {this.localizedNdaTemplate.title}</div> */}

              </div>
              <Row>
                <Col md={5} className={styles.menus} style={{ height: this.state.height }}>
                  {this.state.create && this._renderUntitledNDA()}
                  {this._renderItems()}
                </Col>
                <Col md={7} className={styles.menuDetails} style={{ height: this.state.height }}>
                  {this._renderDetailView()}
                </Col>
              </Row>
            </div>
          }
        </Measure>  
        <Slider.Dialog width="30vw" show={this.state.deleting != null}>
          <DeleteNDASignatureContainer
            item={this.state.deleting}
            onDeletion={this._onDeleteSuccess}
            onCancel={
              () => {
                this.setState({
                  deleting: null
                })
              }
            }
          />
        </Slider.Dialog>
      </div>
    );
  }

  _renderUntitledNDA() {
    return (
      <NDATemplateView />
    )
  }

  _renderItems() {
    if(!this.props.templates) {
      return false;
    }

    return this.props.templates.map(item => {
      return (
        <NDATemplateView 
          key={item.id}
          value={item} 
          onDelete={this._handleDeleteClick}
        />
      );
    })
  }

  _renderDetailView() {
    if(this.props.loading){
      return false;
    }

    const id = this.props.params.id;
    const empty = !this.state.create && !id;

    if(empty){
      return (
        <div className={styles.emptyMessage}>
          <p className={styles.emptyMessageHeading}>{this.localizedNda.empty_message.title}</p>
          <p className={styles.emptyMessageDescription}>{this.localizedNda.empty_message.description}</p>
        </div>
      );
    }

    return <NDADetailsContainer id={id} />
  }
}


NDATemplatesView.childContextTypes = {
  selection: PropTypes.object
};

export default NDATemplatesView;
